<!-- Schedule/Visit -->
<template>
  <validation-observer ref="form">
    <div class="row">
      <div class="col-lg-12">
        <base-input
          label="Nome do Evento"
          :valid="true"
          type="text"
          placeholder="Nome do Evento"
          v-model="formData.name"
          aria-label="Nome do Evento"
          :required="true"
          rules="required"
          :error="errors[0]"
          success-message="Campo preenchido"
        ></base-input>
      </div>

      <div class="col-lg-12">
        <base-input
          label="Endereço"
          :valid="true"
          type="text"
          placeholder="Endereço"
          v-model="formData.address"
          aria-label="Endereço"
          :required="true"
          rules="required"
          :error="errors[0]"
          success-message="Campo preenchido"
        ></base-input>
      </div>

      <div class="col-lg-12">
        <base-input
          label="Data e hora da visita"
          :required="true"
          rules="required"
          success-message="Campo preenchido"
        >
          <el-date-picker
            v-model="dateRange"
            :picker-options="{ disabledDate: disabledDate }"
            type="datetimerange"
            range-separator="-"
            start-placeholder="Data início"
            end-placeholder="Data fim"
            prefix-icon="fa fa-calendar"
            format="dd/MM/yyyy HH:mm"
            unlink-panels
            :required="true"
            :editable="true"
          ></el-date-picker>
        </base-input>
      </div>

      <div class="col-lg-12 px-0 mb-3">
        <label class="form-control-label d-block mb-3 col-12">Enviar Convites</label>
        <el-cascader
          :disabled="formData.id"
          class="col-lg-12"
          v-model="invitationType"
          :options="freeArrayOptions"
          @change="handleInvitationTypeChange"
        >
        </el-cascader>

        <div class="col-lg-12 mt-2">
          <tags-input
            v-if="formData.free"
            v-model="formData.free_array"
            placeholder="Insira um email"
          ></tags-input>
          <span class="text-danger" v-if="(formData.free_array || []).find(email => validateEmail(email))">Insira apena emails válidos</span>
        </div>
      </div>

      <div class="col-lg-12">
        <base-input
          label="Descrição"
          :valid="true"
          type="text"
          placeholder="Descrição"
          v-model="formData.note"
          aria-label="Descrição"
        ></base-input>
      </div>

      <div class="form-group col-lg-12">
        <label class="form-control-label d-block mb-3">Status cor</label>
        <base-color-selector v-model="formData.color" :colors="colors" />
      </div>

      <div class="col-lg-12">
        <label class="form-control-label d-block mb-3">Anexar Imagens e Vídeos</label>
        <file-input
          :files="[]"
          @update:files="addFile($event)"
          multiple
        ></file-input>
        <br>
        <br>
        <!-- @remove="support.files = support.files.filter((f) => f != $event)" -->
        <file-list :files.sync="files" remove @remove="removeFile($event)" />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import BaseColorSelector from "@/components/BaseColorSelector.vue";
import { DatePicker, Cascader } from "element-ui";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import FileList from "@/components/FileList";
import TagsInput from "@/components/Inputs/TagsInput";
import { extend } from "vee-validate";

import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});
export default {
  name: "EventForm",
  components: {
    BaseColorSelector,
    Multiselect,
    FileList,
    [DatePicker.name]: DatePicker,
    [Cascader.name]: Cascader,
    TagsInput,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        id: null,
        title: "",
        start: null,
        end: null,
        color: "",
        note: "",
        client: "",
        email: "",
        address: "",
        visitType: "",
        client_id: null,
      }),
    },
    disabledDate: {
      type: Function,
      default: () => () => false,
    },
  },
  data: () => ({
    clients: [],
    clientRequestIndex: 0,
    invitationType: [],
    errors: [],
    colors: [
      { value: "bg-purple",  name: "Ciclo de vendas" },
      { value: "bg-pink",    name: "Apresentação" },
      { value: "bg-success", name: "Orientação" },
      { value: "bg-dark",    name: "Geral" },
    ],
    freeArrayOptions: [
        {
          value: "carteira de clientes",
          label: "Carteira de Clientes",
          children: [
            {
              value: "clients",
              label: "Meus Clientes",
            },
            {
              value: "all_clients",
              label: "Todos Clientes",
            },
          ],
        },

        {
          value: "colaboradores",
          label: "Colaboradores",
          children: [
            {
              value: "vendedor",
              label: "Vendedor",
              children: [
                {
                  value: "salesmans",
                  label: "Meus vendedores",
                },
                {
                  value: "all_salesmans",
                  label: "Todos vendedores",
                },
              ],
            },

            {
              value: "gestor",
              label: "Gerente Comercial",
              children: [
                {
                  value: "all_managers",
                  label: "Todos gerentes comerciais",
                },
                {
                  value: "managers",
                  label: "Meu Gerente Comercial",
                },
              ],
            },
          ],
        },
        {
          value: "livre",
          label: "Livre",
        },
        {
          value: "todos",
          label: "Todos",
        },
      ],
  }),
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    dateRange: {
      get() {
        if (this.formData.date_start && this.formData.date_end) {
          return [this.formData.date_start, this.formData.date_end];
        }

        return null;
      },
      set(value) {
        if (value && value.length === 2){
          this.formData = { ...this.formData, date_start: value[0], date_end: value[1] };
          return
        }

        this.formData = { ...this.formData, date_start: null, date_end: null };
      },
    },
    files: {
      get() {
        return this.value.media || [];
      },
      set(value) {
        this.formData = { ...this.formData, media: value };
      },
    },
  },
  mounted() {
  },
  methods: {
    validateEmail(email) {
      const re = /^$|\S+@\S+\.\S+/;
      return re.test(email) ? "" : "Email inválido";
    },
    clearForm() {
      this.$refs.form.reset();
    },
    addFile(files) {
      this.files = [...this.files, ...files];
    },
    removeFile(file) {
      if (!file.signed_id) return;
      if (!this.formData.destroy_media) this.formData.destroy_media = [];

      this.formData.destroy_media = [...this.formData.destroy_media, file.signed_id];
    },
    handleInvitationTypeChange(value) {
      if (value.length == 0) return;

      const lastValue = value[value.length - 1];

      console.debug("[EventForm][handleInvitationTypeChange] handleInvitationTypeChange", lastValue)

      this.formData.free          = false;
      this.formData.clients       = false;
      this.formData.clients_all   = false;
      this.formData.salesmans     = false;
      this.formData.salesmans_all = false;
      this.formData.managers      = false;
      this.formData.manager_all   = false;

      switch (lastValue) {
        case "todos":
          this.formData.clients_all = true;
          this.formData.manager_all = true;
          this.formData.salesmans   = true;
          break;
        case "livre":
          this.formData.free = true;
          break;
        case "clients":
          this.formData.clients = true;
          break;
        case "all_clients":
          this.formData.clients_all = true;
          break;
        case "salesmans":
          this.formData.salesmans = true;
          break;
        case "all_salesmans":
          this.formData.salesmans_all = true;
          break;
        case "managers":
          this.formData.managers = true;
          break;
        case "all_managers":
          this.formData.manager_all = true;
          break;
      }
    },
  },
}
</script>

<style lang="scss">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@/assets/sass/core/vendors/fullcalendar";

</style>
